module.exports = __webpack_public_path__ + "static/media/forgot-password.935e7046.jpg";